<template>
  <button
    class="relative block overflow-hidden bg-black"
    @click="handleSetIsOpen(true)"
  >
    <img
      :src="videoData.imageUrl"
      :alt="videoData.title"
      loading="lazy"
      class="pointer-events-none absolute left-0 top-0 block h-full w-full object-cover"
    />
    <VideoPlayerButton
      class="absolute left-2/4 top-2/4 h-[50px] w-[50px] -translate-x-2/4 -translate-y-2/4 tablet:h-16 tablet:w-16 desktop:h-[72px] desktop:w-[72px]"
    />
    <div class="hidden">
      <slot name="hidden" />
    </div>
    <Teleport to="body" :disabled="!isOpen">
      <Transition name="modal">
        <div
          v-if="isOpen"
          class="fixed left-0 top-0 z-lightbox flex h-full w-full items-center justify-center bg-black/60"
          @click="handleSetIsOpen(false)"
        >
          <div class="relative w-[calc(100%-20px)] max-w-[960px]">
            <VideoModel
              :video-title="videoData.title"
              :video-url="videoData.url"
              :video-image-url="videoData.imageUrl"
              :is-auto-play="videoData.isAutoPlay"
            />
            <button
              class="absolute -top-6 right-0 flex h-6 w-6 items-center justify-center bg-black desktop:-right-6 desktop:top-0"
              @click="handleSetIsOpen(false)"
            >
              <IconClose class="h-6 w-6 text-white" />
            </button>
          </div>
        </div>
      </Transition>
    </Teleport>
  </button>
</template>

<script setup lang="ts">
  interface IVideoData {
    title: string;
    description: string;
    url: string;
    imageUrl: string;
    isAutoPlay?: boolean;
  }

  interface IProps {
    videoData: IVideoData;
  }

  withDefaults(defineProps<IProps>(), {
    videoData: () => ({
      title: '',
      description: '',
      url: '',
      imageUrl: '',
      isAutoPlay: false,
    }),
  });

  const mainStore = useMainStore();

  const id = ref<string>('');
  const isOpen = ref<boolean>(false);

  const handleSetIsOpen = (payload: boolean): void => {
    isOpen.value = payload;
  };

  watch(isOpen, (value: boolean) => {
    mainStore.isBodyFixed = value;
  });

  onMounted(() => {
    if (window.videoModelCount) {
      window.videoModelCount += 1;
    } else {
      window.videoModelCount = 1;
    }
    id.value = `video-model-id-${window.videoModelCount}`;
  });

  onBeforeUnmount(() => {
    mainStore.isBodyFixed = false;
  });

  export type { IVideoData };
</script>
